// loader.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LoaderService {
    private loadingSubject = new BehaviorSubject<boolean>(false);
    private activeRequests = 0;
    loading$ = this.loadingSubject.asObservable();

    show() {
        this.activeRequests++;
        if (this.activeRequests === 1) {
            this.loadingSubject.next(true);
        }
    }

    hide() {
        this.activeRequests = Math.max(0, this.activeRequests - 1);
        if (this.activeRequests === 0) {
            this.loadingSubject.next(false);
        }
    }
}
